import { render, staticRenderFns } from "./StaticFaq.vue?vue&type=template&id=349c5362&scoped=true&"
import script from "./StaticFaq.vue?vue&type=script&lang=js&"
export * from "./StaticFaq.vue?vue&type=script&lang=js&"
import style0 from "./StaticFaq.vue?vue&type=style&index=0&id=349c5362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c5362",
  null
  
)

export default component.exports